export const initFAQ = () => {
	const FAQSections = document.querySelectorAll( 'section.faq' );

	if ( !FAQSections.length )
	{
		return;
	}

	Array.from( FAQSections ).forEach( ( it ) => {
		const checkedInput = it.querySelector( 'input[name*="faq_category"]:checked' );

		it.querySelector( `label[for="${checkedInput.id}"]` ).classList.add( 'checked' );

		it.addEventListener( 'change', ( evt ) => {
			const changedInput = evt.target;
			
			if ( /faq_category/.test( changedInput.name ) )
			{
				it.querySelector( 'label.checked' ).classList.remove( 'checked' );
				it.querySelector( `label[for="${changedInput.id}"]` ).classList.add( 'checked' );
			}

			if ( /faq_question/.test( changedInput.name ) )
			{
				const answer = changedInput.nextElementSibling.nextElementSibling;
                const button = changedInput.parentElement.querySelector('.button');

				const answerMaxHeight = changedInput.checked ? `${answer.querySelector( 'div.markup' ).offsetHeight}px` : '';

				answer.style.maxHeight = answerMaxHeight;

                if (button) {
                    button.innerText = changedInput.checked ? '–' : '+';
                }
			}
		} );
	} );
};
